import PropTypes from 'prop-types';

import isNotEmptyReactElementContent from 'core/utils/content';

import H3 from '../H3';


function Feed(props) {
  const {
    title,
    content,
    card: BaseCard,
    interitemSpacing,
    heroCard: HeroCard,
    headerComponent: Header,
  } = props;

  if (!content?.length) return null;

  return (
    <div>
      <style jsx>{`
        .item
          height 100%
          box-sizing border-box
          break-inside avoid-column
      `}</style>
      <style jsx>{`
        .header
          margin-bottom ${interitemSpacing}px
        .item + .item
          margin-top ${interitemSpacing}px
      `}</style>
      {isNotEmptyReactElementContent(title) && (
        <div className='header'>
          <Header>{title}</Header>
        </div>
      )}
      <div className='container'>
        {content.map((topic, i) => {
          const cardProps = {
            position: i,
            content: topic,
          };
          const Card = HeroCard && !i ? HeroCard : BaseCard;
          return (
            <div className='item' key={topic.id}>
              <Card {...cardProps} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

Feed.propTypes = {
  title: PropTypes.string,
  headerComponent: PropTypes.func,
  card: PropTypes.func.isRequired,
  heroCard: PropTypes.func,
  content: PropTypes.array.isRequired,
  interitemSpacing: PropTypes.number.isRequired,
};

Feed.defaultProps = {
  interitemSpacing: 0,
  headerComponent: H3,
};

export default Feed;
